import { normalizeAgentReferralParam } from '~/utils/agentReferral';

// AM invite links (/auth/register?ref=CODE&am=CODE). `ref` is the partner referral (credit + payouts)
// and carries the AM's referral code; `am` assigns the new signup to the AM and carries their
// agentReference. The two differ once the AM has generated a new referral code.
export const AM_LINK_QUERY_KEY = 'am';
// Read by the signup endpoints (server/utils/auth/accountManagerLink.ts).
export const AM_LINK_COOKIE_KEY = 'dic_am';
export const AM_LINK_COOKIE_MAX_AGE = 60 * 60 * 24 * 30; // 30 days, same as the referral cookie

export const AM_INVITE_LINK_MODES = ['both', 'assign', 'referral'] as const;
export type AmInviteLinkMode = (typeof AM_INVITE_LINK_MODES)[number];

const REGISTER_PATH = 'auth/register';

export type AmInviteCodes = { code: string; referralCode: string | null };

export const inviteLinkNeedsReferralCode = (mode: AmInviteLinkMode): boolean => mode !== 'assign';

// null when the mode needs a referral code and the AM has none (retired, not regenerated yet).
export const buildAmInviteLink = (siteUrl: string, codes: AmInviteCodes, mode: AmInviteLinkMode): string | null => {
  if (inviteLinkNeedsReferralCode(mode) && !codes.referralCode) return null;
  const url = new URL(REGISTER_PATH, siteUrl.endsWith('/') ? siteUrl : `${siteUrl}/`);
  if (codes.referralCode && inviteLinkNeedsReferralCode(mode)) url.searchParams.set('ref', codes.referralCode);
  if (mode !== 'referral') url.searchParams.set(AM_LINK_QUERY_KEY, codes.code);
  return url.toString();
};

// Same shape as a referral code (an agentReference).
export const normalizeAmLinkParam = (value: string | string[] | null | undefined): string | null =>
  normalizeAgentReferralParam(value);
